export const disableScroll = (disabled: boolean): void => {
  const bodyClassList = document.body.classList

  if (disabled) {
    bodyClassList.add('overflow-hidden')
  } else {
    bodyClassList.remove('overflow-hidden')
  }
}
